import { useState, useEffect } from 'react';
import { tableHeader, tableData, title, btnOne } from '../utils/style';
import { url } from '../utils/config';
import axios from 'axios';
import AddVanEquipment from '../modals/AddVanEquipment';
import { toast } from 'react-toastify';
import Button from '../reusable_components/Button';
import Table from '../reusable_components/Table';
import { render } from '@testing-library/react';


function WorkshopEquipments() {
    const [ vanEquipments, setVanEquipments ] = useState([]);
    const [ specialEquipments, setSpecialEquipments ] = useState([]);
    const [ showAddEquipments, setShowAddEquipments ] = useState(false);
    const [ vanIndex, setVanIndex ] = useState(0);
    const [ history, setHistory ] = useState([]);
    const [ showHistory, setShowHistory ] = useState(false);
    const [ reloadTable, setReloadTable ] = useState(false)

    useEffect(() => {
        (
            async function fetchMobileWorkshops() {
                try {
                    const reqUrl = url + '/van_equipments';
                    const token = window.localStorage.getItem('token');
                    const headers = { authorization: `bearer ${token}` };
                    const { data } = await axios.get(reqUrl, { headers });
                    setSpecialEquipments(data.specialEquipments);
                    setVanEquipments(data.vans)
                } catch (error) {
                    toast.error(error.response.data.message, { autoClose: 3000 })
                }
            }
        )()
    }, [])


    async function fetchWorkshopInventoryTransfer(id) {
        try {
            const reqUrl = url + '/workshop_inventory_transfer/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            console.log(data);
            // setMobileWorkshops(data);
            // '/inventory/mobile_workshop/transfer'
        } catch (error) {
            console.log(error)
        }
    }

    const options = [
        {
            header: 'Equipment',
            key: 'name',
        },
        {
            header: 'Total',
            render: (data) => { return vanEquipments[vanIndex]?.van_equipments?.filter(ve => ve.special_equipment_id === data.id).length},
        },
        {
            header: 'In Stock',
            key: 'inStock',
        }
    ]

    return(
        <div className="p-4">
            {
                showAddEquipments && vanEquipments.length != 0 && 
                <AddVanEquipment 
                    setShowAddForm={setShowAddEquipments} 
                    specialEquipments={specialEquipments} 
                    mobileVanId={vanEquipments[vanIndex]['id']}
                    reload={setReloadTable}
                />
            }
            <div className={title}>Mobile Workshop</div>
            <div className='text-center'>
                <select className='px-12 py-3 outline-none border border-gray-500 rounded-md font-semibold' onChange={e => setVanIndex(e.target.value)}>
                    
                    {
                        vanEquipments.length > 0 && vanEquipments.map((eq, ind) => <option value={ind} key={ind}>{eq.make + ' / ' + eq.model}</option>)
                    }
                </select>
            </div>
            <div className='grid grid-cols-5'>
                {/* <div className='col-span-1 pr-4'>
                    <div className='text-2xl font-semibold py-2 '>Chargers</div>
                    <div className='text-center border border-black'>
                        <div className='p-12 font-semibold text-4xl text-green-500'>{ ''}</div>
                        <div className='p-2 font-semibold text-lg '>In Stock</div>
                    </div>
                </div> */}
                <div className='col-span-5'>
                    <div className='flex justify-end pb-4'>
                        {/* <div className='text-2xl font-semibold py-2 '>Special Equipments</div> */}
                        <span><Button name={'Add Equipment'} className={btnOne} clickHandler={() => setShowAddEquipments(true)} /></span>
                    </div>

                    <Table 
                        options={options} 
                        // url={url + '/mobile_vans'} 
                        tableData={specialEquipments}
                        // pagination 
                        // clickHandler={() => setShowAddVan(!showAddVan)}
                        // btnTitle={'Mobile Van'}
                        noButton
                        noFilter
                        // excludeFilter={excludeFilter}
                    />
                    {/* <table className='w-full'>
                        <thead>
                            <tr>
                                <th className={ tableHeader }>Equipment</th>
                                <th className={ tableHeader }>Total</th>
                                <th className={ tableHeader }>In Stock</th>
                                <th className={ tableHeader }>{''}</th>
                            </tr>
                        </thead>
                        <div className='mt-2 h-4 w-full'></div>
                        <tbody>
                            {
                                vanEquipments.length > 0 && specialEquipments.map((se, index) => 
                                <tr key={index} className="border border-gray-400">
                                    <td className={ tableData }>{se.name}</td>
                                    <td className={ tableData }>{vanEquipments[vanIndex].van_equipments.filter(ve => ve.special_equipment_id === se.id).length}</td>
                                    <td className={ tableData }>
                                        <span className='text-green-400 cursor-pointer' onClick={() => setShowHistory(true)}>{se.inStock}</span>
                                    </td>
                                    <td className={ tableData }><span className='text-blue-400 cursor-pointer' onClick={() => fetchWorkshopInventoryTransfer()}>Inventory Transfer</span></td>
                                    <td className={ tableData }>{car.trim ? car.trim.map((t, i) => `${i === 0 ? '' : '/'}${t}`) : null}</td>
                                    <td className={ tableData }>{car.year ? car.year.map((y, i) => `${i === 0 ? '' : '/'}${y}`) : null}</td>
                                </tr>)
                            }
                        </tbody>
                    </table> */}
                </div>
            </div>
            {
                showHistory ? 
                <div className='fixed z-10 top-64 flex justify-center w-full'>
                    <div className='border border-gray-200 rounded-md p-8 inline-block bg-white'>
                        <div className='text-right mb-4'>
                            <span className='text-red-500 cursor-pointer font-bold' onClick={() => setShowHistory(false)}>X</span>
                        </div>
                        <div className='flex justify-between px-16 py-4'>
                            <div className='text-lg font-semibold text-green-400 mr-4'>Check-In Date:</div>
                            <div className='font-semibold text-gray-600'>01/08/2022</div>
                        </div>
                        <div className='flex justify-between px-16 py-4'>
                            <div className='text-lg font-semibold text-red-400 mr-4'>Check-Out Date:</div>
                            <div className='font-semibold text-gray-600'>15/08/2022</div>
                        </div>
                        <div className='flex justify-between px-16 py-4'>
                            <div className='text-lg font-semibold text-blue-400 mr-4'>Assigned to:</div>
                            <div className='font-semibold text-gray-600'>Technician 1</div>
                        </div>
                        <div className='flex justify-between mt-8'>
                            <div className='font-semibold cursor-pointer'>{`< Prev`}</div>
                            <div className='font-semibold cursor-pointer'>{`Next >`}</div>
                        </div>
                    </div>
                </div> : null
            }
        </div>
    )
}

export default WorkshopEquipments;